import { Flex } from '@talos/kyoko';
import { useMemo } from 'react';
import type { MarketSelectorRow } from './blotter/types';
import { useMarketSelectorContext } from './MarketSelectorContext';

interface MarketSelectorSelectionSummaryProps {
  rows: MarketSelectorRow[];
}

export const MarketSelectorSelectionSummary = ({ rows }: MarketSelectorSelectionSummaryProps) => {
  const { enrichments, extensions } = useMarketSelectorContext();
  const summary = useMemo(() => {
    const summaries = [...enrichments, ...extensions]
      .map(contribution => contribution.selectionSummary)
      .filter(summary => summary != null);
    if (import.meta.env.DEV && summaries.length > 1) {
      throw new Error('Multiple Market Selector contributions define selectionSummary');
    }
    return summaries[0];
  }, [enrichments, extensions]);

  if (!summary) {
    return null;
  }

  return (
    <Flex minHeight="28px" px="spacing8" borderTop="1px solid var(--backgroundDivider)">
      {summary(rows)}
    </Flex>
  );
};
